import { useTranslation } from 'react-i18next';
import { formatDateTime } from '~/utils';
import type { ComparedTally } from './comparedTally';

type HeadedComparison = {
  tally: ComparedTally | null;
  requestForQuote: { useTallyPrice: boolean; createdAt: string };
};

export function useComparisonHeadings(
  comparedRequests: HeadedComparison[]
): (string | undefined)[] {
  const { t } = useTranslation('rfq-view');
  const isOneOfSeveral = comparedRequests.length > 1;
  const baseHeadingOf = ({ tally, requestForQuote }: HeadedComparison) => {
    if (tally !== null) {
      return tally.cannedTallyName === null
        ? t('rfq_view.quote_comparison.random_tally_heading', {
            productName: tally.productName,
          })
        : t('rfq_view.quote_comparison.canned_tally_heading', {
            productName: tally.productName,
            tallyName: tally.cannedTallyName,
            tallyCount: tally.cannedTallyCount,
          });
    }
    if (!isOneOfSeveral) return undefined;
    return t(
      requestForQuote.useTallyPrice
        ? 'rfq_view.quote_comparison.tally_priced_heading'
        : 'rfq_view.quote_comparison.item_priced_heading'
    );
  };
  const baseHeadings = comparedRequests.map(baseHeadingOf);
  const isSharedHeading = (heading: string | undefined) =>
    baseHeadings.filter((otherHeading) => otherHeading === heading).length > 1;

  return comparedRequests.map((comparedRequest, index) => {
    const heading = baseHeadings[index];
    if (heading === undefined || !isSharedHeading(heading)) return heading;
    return t('rfq_view.quote_comparison.heading_with_sent_at', {
      heading,
      sentAt: formatDateTime(comparedRequest.requestForQuote.createdAt),
    });
  });
}
